export default __webpack_public_path__ + "static/media/setup-cronos.c8f0174f.png";